<template>
  <div id="staff-action-report">
    <vs-row vs-type="flex" vs-w="12">
      <global-filter
        ref="filterer"
        :tableOptions="tableOptions"
        :filterOptions="filterOptions"
        :filterChips="filterChips"
        :filterOptionNames="filterOptionNames"
        :isActive="isFilterActive"
        @saveOptions="saveOptions"
        @close="isFilterActive = false"
      />
    </vs-row>

    <vs-row v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between" class="mb-4 mt-2">
        <vs-col vs-type="flex" vs-w="6" vs-align="center">
            <vx-tooltip text="Detaylı Filtreleme" position="top">
                <vs-button @click="isFilterActive = !isFilterActive" class="panel-action text-warning xlarge-button panel-action-box-shadow" color="transparent" icon-pack="pickicon" icon="icon-pick-filter"></vs-button>
            </vx-tooltip>
            <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter" class="ml-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather" icon="icon-slash" radius color="transparent"/>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center">
             <vs-chip color="white" class="panel-action-box-shadow px-1 mr-2" v-for="(chip, index) in filterChips" :key="index" @click="removeFilter(chip.col, index)" closable>
                <span class="bold text-xsmaller text-dark">{{ chip.name + " :" }}</span>
                <span class="weight-600 italic text-xsmaller text-primary ml-1">{{ chip.value }}</span>
            </vs-chip>
        </vs-col>
    </vs-row>

    <div v-if="reportData">
        <staff-action-report-min 
            :items="reportData.items" 
            :totalAmount="reportData.totalAmount" 
            :totalQuantity="reportData.totalQuantity" 
        />
    </div>
  </div>
</template>

<script>
import GlobalFilter from "../../GlobalFilter.vue";
import StaffActionReportMin from "./StaffActionReportMin.vue";
import { GetStaffActionReport } from "@/api/Reports";
import _ from 'lodash';

export default {
  components: {
    GlobalFilter,
    StaffActionReportMin
  },
  data() {
    return {
      isFilterActive: false,
      tableOptions: {
        branch: null,
        personal: null,
        actionType: null,
        isOpenBill: null,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        table: null,
        targetTable: null
      },
      filterOptions: ["branch", "personal", "actionType", "isOpenBill", "dateRange", "table", "targetTable"],
      filterOptionNames: ["Şube", "Personel", "İşlem Türü", "Adisyon Durumu", "Tarih Aralığı", "Masa", "Hedef Masa"],
      filterChips: [],
      reportData: null
    };
  },
  methods: {
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
      this.fetchData();
    },
    clearFilter() {
      this.tableOptions = {
        branch: this.$currentUser.branch,
        personal: null,
        actionType: null,
        isOpenBill: null,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        table: null,
        targetTable: null
      };
      this.filterChips = [];
      this.fetchData();
    },
    removeFilter(col, index) {
      if (col === 'branch') {
          this.tableOptions[col] = this.$currentUser.branch;
      } else {
          this.tableOptions[col] = null;
      }
      this.filterChips.splice(index, 1);
      this.fetchData();
    },
    fetchData() {
      this.$vs.loading();
      let payload = _.cloneDeep(this.tableOptions);
      


      GetStaffActionReport(payload)
        .then(res => {
          if (res && res.status === 200) {
            this.reportData = res.data;
          } else {
              this.$vs.notify({
                  color: 'danger',
                  title: 'Hata',
                  text: 'Veriler yüklenirken bir hata oluştu.'
              });
          }
        })
        .catch(() => {
            this.$vs.notify({
                color: 'danger',
                title: 'Hata',
                text: 'Sunucu bağlantı hatası.'
            });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  created() {
    this.tableOptions.branch = this.$currentUser.branch;
    // Initial fetch might need a slight delay or proper initialization of chips if we want them to show up
    this.fetchData();
  }
};
</script>

<style scoped>
.panel-action-box-shadow {
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
}
.bold { font-weight: bold; }
</style>
